<p class="modal-title">HSAs during pre-retirement years</p>
<div class="modal-close" (click)="onClose()">
    <img alt="Close" src="../../../assets/icons/circle-x.svg" />
</div>
<p>If you plan to cover some of your pre-retirement expenses with other savings, use the slider to lower the
    out-of-pocket amount so we can factor that into your retirement projection. Or, if you want to plan more
    conservatively, use the slider to increase the estimated costs. Any HSA contributions not withdrawn to cover
    pre-retirement health expenses may grow and be available to fund in-retirement costs.</p>
    